import type { CompanyEntity } from "@/lib/types/company";
import { ENHANCED_COMPANIES_CONFIG } from "@/features/companies/components/EnhancedCompaniesConfig";
import { ENHANCED_COMPANY_DETAIL_CONFIG } from "@/features/companies/components/CompanyDetailConfig";
import {
  useCompaniesTagsConfigEnhancer,
  useCompaniesConfigEnhancer,
} from "@/lib/hooks/api/shared/config-enhancers";
import type { SimpleTableConfig } from "@/components/shared/UniversalCRMTable/types";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// COMPANIES ENTITY DEFINITION
// ============================================================================
// Single source of truth for all companies UI configuration.
// Column change: edit tableConfig.fields (features/companies/components/EnhancedCompaniesConfig.ts).
// ============================================================================

function useCompaniesEnhancer(
  config: SimpleTableConfig<CompanyEntity>
): SimpleTableConfig<CompanyEntity> {
  // Apply tags first, then technology options
  const withTags = useCompaniesTagsConfigEnhancer({ config });
  return useCompaniesConfigEnhancer({ config: withTags });
}

export const companiesEntity = defineEntity<CompanyEntity>({
  tableConfig: ENHANCED_COMPANIES_CONFIG,

  detailConfig: ENHANCED_COMPANY_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },

  // Injects tag options + technology options into fields at render time
  useConfigEnhancer: useCompaniesEnhancer,
});
